var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex"},_vm._l((_vm.navItemArr),function(item,index){return _c('div',{staticClass:"navbar",class:index == _vm.activeIndex ? 'active' : ''},[_c('router-link',{attrs:{"to":item.url}},[_c('img',{attrs:{"src":index == _vm.activeIndex ? item.selected : item.icon}}),_c('p',[_vm._v(_vm._s(item.title))])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }